import axios from "axios";
import { getUnitApiBaseFour, SUB_URL } from "../BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const MasterBinService = {
  masterBin_get_bins_details: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.getMaster_get_bins_details}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching master bin details:", error);
      return { status: false, data: [] };
    }
  },
};

export default MasterBinService;